import { useEffect } from "react";

type UseSideBarStickyProps = {
  wrapper: HTMLDivElement | null;
  fixScrollPadding?: boolean;
};

const useSideBarSticky = (props: UseSideBarStickyProps) => {
  const { wrapper, fixScrollPadding } = props;

  useEffect(() => {
    if (!fixScrollPadding || !wrapper) return;
    wrapper.setAttribute("data-scroll-padding", "1");
  }, [fixScrollPadding, wrapper]);
};
export default useSideBarSticky;
